import { RouteRecordRaw } from 'vue-router'
import { AppLayoutsEnum } from '@/layouts/layouts.types'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/404',
    name: 'not-found',
    component: () => import('./views/NotFound.vue'),
    meta: {
      layout: AppLayoutsEnum.empty
    }
  }
]

export default routes
